import {defaultCountry, countryTextMap} from './../config/app-config';

export default function autosuggestOnSelectionhandler(changes, updateQueryCaller) {
  let country = defaultCountry;
  if (changes && changes.selectedItem && changes.selectedItem.xtr) {
    country =
      changes.selectedItem.xtr.cc === 'IN'
        ? countryTextMap.india.key
        : countryTextMap.international.key;
    if (changes.selectedItem.xtr.flt) {
      // ! if there is an explicit product ask
      // ! otherwise, filter stuff coming from voyager will anyway get consumed at UpdateSearch level
      // const voyagerTransformedFilter = voyagerResultToFilter(
      //   changes.selectedItem,
      //   filterInState,
      // );
      // updateFilterCaller({...voyagerTransformedFilter});
    }
  }
  updateQueryCaller({
    destination: {...changes.selectedItem},
    country: country,
  });
}
